/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';
import { AllOption, ClientSearch } from '@core/models';
import { Client, ClientStatusEnum } from '@truckstop-tms/zuum-lib';

export const loadClients = createAction('[ClientsList] Load Client List', props<{ clientSearch: ClientSearch }>());
export const loadClientsSuccess = createAction(
  '[ClientsList] Load Client List Success',
  props<{ clients: Client[]; totalNumberOfClients: number }>()
);
export const loadClientsFailure = createAction(
  '[ClientsList] Load Client List Failure',
  props<{ errorMessage: string }>()
);
export const setStatusFilters = createAction(
  '[ClientsList] Set Client List Status Filter',
  props<{ statusFilter: (ClientStatusEnum | AllOption.All)[] }>()
);

export const updateClientStatus = createAction(
  '[ClientsList] Update Client Status',
  props<{ client: Client; status: ClientStatusEnum }>()
);
export const updateClientStatusSuccess = createAction(
  '[ClientsList] Update Client Status Success',
  props<{ client: Client }>()
);
export const updateClientStatusFailure = createAction(
  '[ClientsList] Update Client Status Failure',
  props<{ errorMessage: string }>()
);

export const cancelClientPlan = createAction(
  '[ClientsList] Cancel Client Plan',
  props<{ cancelationReason: string; client: Client }>()
);
export const cancelClientPlanSuccess = createAction(
  '[ClientsList] Cancel Client Plan Success',
  props<{ client: Client }>()
);
export const cancelClientPlanFailure = createAction(
  '[ClientsList] Cancel Client Plan Failure',
  props<{ errorMessage: string }>()
);
